import { ProcessLine } from "../../types";
import { shareSubjectWithDelay } from "../apiHelper";
import { getMLCINTBWarningIndexDataObserver, getMLCTBCFWarningIndexDataObserver, getMLCWarningIndexStatusObserver } from "./MLCModel";
import {
    getMLCTBCFOverviewDataObservable, getMLCINTBOverviewDataObservable,
    getMLCSingleParamTrendsDataObservable,
    getINTBWarningIndexMessagesDataObservable,
    getTBCFWarningIndexMessagesDataObservable,
} from "./MLCServices";


export const getMLCINTBOverviewData = (line: ProcessLine) => getMLCINTBOverviewDataObservable(line);
export const getMLCTBCFOverviewData = () => getMLCTBCFOverviewDataObservable();

export const getTBCFMLCWarningIndexTableDataWithFactoryScheme = () => shareSubjectWithDelay(getMLCTBCFWarningIndexDataObserver())

export const getINTBMLCWarningIndexTableDataWithFactoryScheme = () => shareSubjectWithDelay(getMLCINTBWarningIndexDataObserver())

export const getINTBWarningIndexMessages = () => getINTBWarningIndexMessagesDataObservable();
export const getTBCFWarningIndexMessages = () => getTBCFWarningIndexMessagesDataObservable();

export const getMLCSingleParamTrendsData = (paramName: string, line?: ProcessLine) => getMLCSingleParamTrendsDataObservable(paramName, line);

export const getMLCWarningIndexStatus = () => getMLCWarningIndexStatusObserver();